import { useMutation } from '@apollo/client'

import { disableUserAccessMutation } from '../../../apolloClient/operations/admin/disableUserAccessMutation'
import errorService from '../../../utils/analytics/error'
import feedback from '../../../utils/feedback'

export const useDisableUserAccess = () => {
  const [disableUserAccess] = useMutation(disableUserAccessMutation, {
    onCompleted: () => {
      feedback.success({
        content: 'Access updated successfully',
      })
    },
    onError: error => {
      errorService.report(error, 'update user access')
      feedback.error({
        content: error.message,
        title: 'Error updating user access',
      })
    },
  })

  return { disableUserAccess }
}
